export const locale = {
    lang: 'es',
    data: {
      'TOOLBAR': {
          'PERFIL': 'Mi perfil' ,
          'INBOX': 'Bandeja de entrada',
          'LOGOUT': 'Salir',
          'ADMIN': 'conectado como:',
          'LOGIN':'Inicio de sesión: ',
          'GOPROFILE':'Profile',
          'CITIES':{
            '0':'',
            '1':'Ciudad de México',
            '2':'San salvador',
            '3':'Hong kong',
            '4':'Singapure',
            '5':'Istanbul',
            '6':'Victoria',
            '8':'Ciudad de México',
            '11':'São Paulo',
            '14':'Ciudad de México',
            '15':'Madrid',
            'IZZI':'Ciudad de México',
            'MX':'Ciudad de México',
            '18':'Ciudad de México',
            'AMCO':'Ciudad de México',
            '19':'Ciudad de México',
        },
        'LOGOUT_MODAL': {
          'TEXTO': '¿Está seguro de salir del sistema?',
          'SI': 'Si',
          'NO': 'No'
        }
      }
    }
};
